import React from 'react';
import styled from 'styled-components';

import scrollToTop from '../../../../../shared/utils/scrollToTop';

const handleScrollToTop = () => {
  scrollToTop();
};

const BackToTopCard = () => (
  <WrapperDiv onClick={handleScrollToTop}>
    <WrapperSpan>
      <TextSpan>BACK TO TOP</TextSpan>
    </WrapperSpan>
  </WrapperDiv>
);

export default BackToTopCard;

const WrapperDiv = styled.div(
  props => `
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  margin: 0 0 ${props.theme.spacing.base} 0;
  background-color: ${props.theme.colors.white.base};
  border-radius: ${props.theme.misc.borderRadius.custom(30)};
  padding: ${props.theme.spacing.base};
  box-shadow: 0 ${props.theme.spacing.small.s1} ${props.theme.spacing.small.s7} 0 ${
    props.theme.colors.shadow.light
  };
  align-items: center;
  justify-content: center;
  color: ${props.theme.colors.blue.base}
`,
);

const WrapperSpan = styled.div(
  props => `
  display: inline-flex;
  cursor: pointer;
`,
);

const TextSpan = styled.span(
  props => `
  line-height: ${props.theme.font.lineHeight.base};
  font-size: ${props.theme.font.base};
  font-family: ${props.theme.font.fontFamily};
  font-weight: bold;
`,
);

const ArrowUpIconWrapperSpan = styled.span(
  props => `
  height: 1.6rem;
  width: 1.6rem;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  margin: ${props.theme.spacing.small.s2} 0 0 ${props.theme.spacing.small.s5};
  font-size: ${props.theme.font.small.font8};
`,
);
